import * as R from 'ramda';

import isHandledBySportsApi from '@app/utils/isHandledBySportsApi';
import sportsApi from '@app/utils/sportsApi';
import { normalize, schema } from 'normalizr';

const socialAccountsList = new schema.Entity('socialAccountsList', undefined, {
    idAttribute: value => value.account.platformUserId,
});

const createInvalidResponseError = response => {
    const error = new Error(
        response?.message || 'Unable to save Facebook pages.',
    );
    error.wasHandledByApi = isHandledBySportsApi(response);
    return error;
};

const hasPlatformUserId = value => Boolean(value?.account?.platformUserId);

const toShortFacebookPictureUrl = platformUserId =>
    `https://graph.facebook.com/${encodeURIComponent(
        platformUserId,
    )}/picture?type=large`;

const prepareFacebookAccountForSave = clientAuthorizedAccount => {
    const platformUserId = clientAuthorizedAccount?.account?.platformUserId;

    if (!platformUserId) {
        return clientAuthorizedAccount;
    }

    return {
        ...clientAuthorizedAccount,
        account: {
            ...clientAuthorizedAccount.account,
            profilePictureUrl: toShortFacebookPictureUrl(platformUserId),
        },
    };
};

const saveFbPages =
    store => async (state, clientId, clientAuthorizedAccount) => {
        const userClientId = state.user.selectedUserClientId;
        const clientAuthorizedAccounts = Array.isArray(clientAuthorizedAccount)
            ? clientAuthorizedAccount
            : [clientAuthorizedAccount];
        const requestAccounts = clientAuthorizedAccounts.map(
            prepareFacebookAccountForSave,
        );

        const response = await sportsApi
            .url(`/clients/${clientId}/authorized-accounts`)
            .json(requestAccounts)
            .post()
            .json();

        if (!Array.isArray(response) || !response.every(hasPlatformUserId)) {
            throw createInvalidResponseError(response);
        }

        const normalizedData = normalize(response, [socialAccountsList]);

        const existingPages = R.clone(
            store.getState().clients[userClientId].socialAccounts.facebook
                .linkedPages,
        );

        const pages = R.merge(
            normalizedData.entities.socialAccountsList || {},
            existingPages,
        );

        store.setState(
            R.evolve(
                {
                    clients: {
                        [userClientId]: {
                            socialAccounts: {
                                facebook: {
                                    linkedPages: R.always(pages),
                                },
                            },
                        },
                    },
                },
                store.getState(),
            ),
            true,
        );
    };

export default saveFbPages;
